import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      // Show after scrolling past 600px (approx hero height)
      setIsVisible(latest > 600);
    });
  }, [scrollY]);
  return <AnimatePresence data-id="element-43">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 p-4 z-50 md:hidden bg-gradient-to-t from-black via-black/90 to-transparent pt-8" data-id="element-44">
          <a href="#comprar" onClick={e => {
        e.preventDefault();
        document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="flex items-center justify-center w-full px-6 py-4 bg-[#FE2C55] text-white text-lg font-bold rounded-full shadow-lg shadow-[#FE2C55]/20" data-id="element-45">
            Empieza tu Sprint — $27
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-46" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}